import converter from "../../../libs/number-to-words";
import common from "../../common";
import QuestionViewVerbal from "./QuestionViewVerbal";

export default class QuestionViewVerbalFindRest extends QuestionViewVerbal {
    constructor(question) {
        super(question);
    }

    getHeaderText() {
        const data = P3.assets.json("templates");
        const split = this._question.template.split("/");
        let templates = data.templates[split[0]][split[1]];

        if (templates && templates.length > 0) {
            templates = templates.slice().filter(x => this.filterTemplate(x));
        } else {
            return "ERROR: NO TEMPLATE FOUND";
        }

        this._template = P3.utils.selectRandom(templates);
        const words = data.words;

        let text = this._template ? this._template.text : "";
        if (this._template) {
            const names = this.generateWords(this._template.text, words.names, /\[NAME([0-9])?]/g);
            for (const i in names) {
                if (names.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), names[i]);
                }
            }

            const items = this.generateWords(this._template.text, words.items, /\[ITEM([0-9])?]/g);
            for (const i in items) {
                if (items.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), items[i]);
                }
            }

            const currency = this.generateWords(this._template.text, words.currency, /\[CURRENCY([0-9])?]/g);
            for (const i in currency) {
                if (currency.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), currency[i]);
                }
            }

            const itemPairs = this.generateWords(this._template.text, words.item_pairs, /\[ITEM_PAIR([0-9])?]/g);
            for (const i in itemPairs) {
                if (itemPairs.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i)), itemPairs[i][0]);//replace first instance
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), itemPairs[i][1]);//replace the rest
                }
            }

            const enemies = this.generateWords(this._template.text, words.enemies, /\[ENEMY([0-9])?]/g);
            for (const i in enemies) {
                if (enemies.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), enemies[i]);
                }
            }

            const locations = this.generateWords(this._template.text, words.locations, /\[LOCATION([0-9])?]/g);
            for (const i in locations) {
                if (locations.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), locations[i]);
                }
            }

            const nouns = this.generateWords(this._template.text, words.noun_adjective, /\[NOUN]?]/g);
            let adjectiveNounPair = null;
            for (const i in nouns) {
                if (nouns.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), nouns[i].noun);
                    adjectiveNounPair = nouns[i];
                    break;
                }
            }

            let match = text.match(/\[ADJECTIVE([0-9])?]/g);
            if (match) {
                text = text.replace(new RegExp(P3.utils.escape(match[0]), "g"), adjectiveNounPair.adjective[0]);
                text = text.replace(new RegExp(P3.utils.escape(match[1]), "g"), adjectiveNounPair.adjective[1]);
            }

            match = text.match(/\[PLURAL]?]/g);
            if (match) {
                text = text.replace(new RegExp(P3.utils.escape(match[0]), "g"), adjectiveNounPair.plural);
            }

            const values = this.generateValues(this._template.text, /\[VALUE([0-9])?]/g);
            for (const i in values) {
                if (values.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), values[i]);
                }
            }

            match = text.match(/\. [a-z]/g);
            if (match) {
                for (let i = 0; i < match.length; ++i) {
                    const s = match[i];
                    text = text.replace(new RegExp(P3.utils.escape(s), "g"), s.toUpperCase());
                }
            }
        }

        return text;
    }

    isCorrect() {
        return this._inputValue.value === this._question.answer.value;
    }

    filterTemplate(x) {
        return true;
    }
}